import { useAuthStore } from '@/lib/authStore';
import { useQuery } from '@tanstack/react-query';
import { apiGet } from '@/lib/api';

/**
 * /company/coming-soon — landing page shown to partner users whose `Partner.type` is not one of
 * the hiring types (Product / Service / Consulting / Startup). Pilot ships the hiring-partner
 * portal only; training / internship / placement / R&D / NGO / government partners land here.
 */
export function CompanyComingSoonPage() {
  const user = useAuthStore((s) => s.user);
  const partnerId = user?.partner;
  const partnerQ = useQuery({
    queryKey: ['company', 'partner', partnerId],
    queryFn: () => apiGet<{ partner: { _id: string; name: string; type: string } }>(`/group/partners/${partnerId}`),
    enabled: !!partnerId,
    retry: false,
  });

  const partnerName = partnerQ.data?.partner.name ?? user?.fullName ?? 'your partner';
  const partnerType = partnerQ.data?.partner.type ?? 'partner';
  const typeLabel = partnerType.replace(/_/g, ' ').toLowerCase();

  return (
    <div className="mx-auto" style={{ maxWidth: 720, padding: '48px 20px' }}>
      <div className="card p-6 grid gap-4" data-testid="company-coming-soon">
        <div>
          <span className="badge badge-warning">Limited portal</span>
        </div>
        <h1 className="h-page m-0">Hello, {partnerName}.</h1>
        <p className="m-0">
          The <b>{typeLabel}</b> portal is on our roadmap. For now, work directly with your college
          TPO — they can post training / internship / other records on your behalf, and you can
          review them via email until this portal lands.
        </p>
        <p className="m-0 helper">
          When the {typeLabel} module ships, we'll turn on your dashboard automatically and email
          you. No action needed on your side.
        </p>
        <div className="flex gap-2 flex-wrap">
          <a className="btn btn-primary" href="mailto:support@kollez.ai?subject=Portal%20access%20for%20my%20partner%20type">
            Talk to us
          </a>
        </div>
      </div>
    </div>
  );
}

export default CompanyComingSoonPage;
